import type { ButtonProps } from '@chakra-ui/react'
import type { FC } from 'react'
import { useState } from 'react'

import { Button } from '@app/components/ui/button'
import { toaster } from '@app/components/ui/toaster'
import ICON_MAP from '@app/utils/iconMap'
import { useRecurringReportConfigurationRunMutation } from '@graphql/queries'

interface Props extends ButtonProps {
  recurringReportConfigurationId: string
}

const AiDashboardReportRunNow: FC<Props> = ({ recurringReportConfigurationId, ...rest }) => {
  const [loading, setLoading] = useState<boolean>(false)
  const [, run] = useRecurringReportConfigurationRunMutation()

  const onClick = () => {
    toaster.create({
      type: 'info',
      title: 'Report',
      description: "We've started running your report and will update it when finished."
    })

    setLoading(true)

    run({
      input: {
        recurringReportConfigurationId
      }
    })
      .then(() => {
        toaster.create({
          type: 'success',
          title: 'Report',
          description: 'Your report has been successfully updated.'
        })
      })
      .finally(() => {
        setLoading(false)
      })
  }

  return (
    <Button size="md" colorPalette="purple" onClick={onClick} loading={loading} {...rest}>
      <ICON_MAP.Play /> Run now
    </Button>
  )
}

export default AiDashboardReportRunNow
